export default "__VITE_ASSET__DBtex7W9__"